export const CHECKBOX_LABEL_ON = 'ON';
export const CHECKBOX_LABEL_OFF = 'OFF';

export const CONTROLLER_VALUE_PROPS = {
  defaultValue: ''
};

export const CONTROLLER_EVENT_DELAY: number = 100;
